// entry.client.js
import createApp from './src/app.js'

const { app, router } = createApp()

/** 与路由 canonical 一致的生产域名 */
const SITE_ORIGIN = 'https://gbwatsapk.com'
const DEFAULT_TITLE = 'FMWhatsApp Download Latest (2026)'
const DEFAULT_DESC =
	'Download FMWhatsApp latest for Android: themes, privacy, install tips. Compare FM WhatsApp APK v10.10—explore secure chat features, then download when ready.'

router.onReady(() => {
	updateMeta(router.currentRoute)

	router.beforeEach((to, from, next) => {
		updateMeta(to)
		next()
	})

	app.$mount('#app')
})

function updateMeta(route) {
	const meta = route.meta || {}
	const title = meta.title || DEFAULT_TITLE
	const description = meta.description || DEFAULT_DESC
	const ogDescription = meta.ogDescription || description
	const canonicalHref = meta.link?.find((link) => link.rel === 'canonical')?.href || SITE_ORIGIN
	const defaultKeyword = 'fmwhatsapp, fm whatsapp, fmwhatsapp download, fm whatsapp apk, gbwhatsapp'

	document.title = title

	setMetaTag('description', description)
	setMetaTag('keywords', meta.keywords || defaultKeyword)

	// Open Graph 使用 property（规范写法）
	setMetaProperty('og:title', title)
	setMetaProperty('og:description', ogDescription)
	setMetaProperty('og:url', canonicalHref)
	setMetaProperty('og:type', 'website')
	setMetaProperty('og:image', `${SITE_ORIGIN}/fm-logo.png`)

	// Twitter Card
	setMetaTag('twitter:card', 'summary_large_image')
	setMetaTag('twitter:title', title)
	setMetaTag('twitter:description', ogDescription)
	setMetaTag('twitter:image', `${SITE_ORIGIN}/fm-logo.png`)

	setLinkTag('canonical', canonicalHref)

	if (meta.noindex) {
		setMetaTag('robots', 'noindex')
	} else {
		setMetaTag('robots', 'index,follow')
	}
}

function setMetaTag(name, content) {
	let element = document.querySelector(`meta[name="${name}"]`)
	if (element) {
		element.setAttribute('content', content)
	} else {
		element = document.createElement('meta')
		element.setAttribute('name', name)
		element.setAttribute('content', content)
		document.head.appendChild(element)
	}
}

/** Open Graph 标签使用 property 属性 */
function setMetaProperty(property, content) {
	let element = document.querySelector(`meta[property="${property}"]`)
	if (element) {
		element.setAttribute('content', content)
	} else {
		element = document.createElement('meta')
		element.setAttribute('property', property)
		element.setAttribute('content', content)
		document.head.appendChild(element)
	}
}

function setLinkTag(rel, href) {
	let element = document.querySelector(`link[rel="${rel}"]`)
	if (element) {
		element.setAttribute('href', href)
	} else {
		element = document.createElement('link')
		element.setAttribute('rel', rel)
		element.setAttribute('href', href)
		document.head.appendChild(element)
	}
}
